import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const CookiesPolicy = () => {
  const sections = [
    `Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and personalize content. Cookies are small data files placed on your device when you visit our website.`,
    `We use the following types of cookies: Strictly Necessary Cookies (required for the website to function and cannot be switched off); Performance Cookies (used to count visits and traffic sources so we can measure and improve site performance); Functional Cookies (enable the website to remember choices you make, such as your preferred language or region); and Targeting Cookies (may be set by our advertising partners to build a profile of your interests and show you relevant content on other sites).`,
    `You can control and/or delete cookies at any time through your browser settings. Please note that disabling cookies may affect the functionality of certain parts of our website. For more information about cookies and how to manage them, visit www.allaboutcookies.org.`,
    `We may also use web beacons, pixel tags, and similar technologies in our emails and on our website to track whether emails are opened and to understand how users interact with our site. This information helps us improve our communications and services.`,
  ];

  return (
    <Container sx={{ my: 10 }} id="cookies">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            COOKIES POLICY
          </Typography>
          {sections.map((text, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {text}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default CookiesPolicy;
